import { atom } from 'recoil';

export const teacherReportState = atom({
  key: 'teacherReportState',
  default: null,
});
